var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00172 8.54686C5.69871 8.54686 5.3959 8.43003 5.16649 8.20062L1.90649 4.94062C1.83317 4.86729 1.83317 4.74349 1.90649 4.67017C1.97982 4.59684 2.10362 4.59684 2.17694 4.67017L5.43694 7.93017C5.74862 8.24184 6.25482 8.24184 6.56649 7.93017L9.82649 4.67017C9.89982 4.59684 10.0236 4.59684 10.0969 4.67017C10.1703 4.74349 10.1703 4.86729 10.0969 4.94062L6.83694 8.20062C6.60754 8.43003 6.30473 8.54686 6.00172 8.54686Z",
    fill: "white",
    stroke: "#92ABFE",
    strokeWidth: 0.367059
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.8f5639d6b38acc7bc2f6b4135e945c3a.svg";
export { ForwardRef as ReactComponent };